<template>
  <img alt="info" :class="iconClass" v-tooltip="infoText" :src="require('@/assets/img/icons/icon-info.svg')">
</template>

<script>
export default {
  name: 'AlertDisplay',
  props: {
    infoText: {
      type: String,
      required: true
    },
    iconClass: {
      type: String,
      default: ''
    }
  }

}
</script>
<style scoped>
.icon-info {
  width:15px;
  height:15px;
}

</style>
